module.exports = __webpack_public_path__ + "images/sprites/ui/icon_question_ea79d5606c6737356d94f99514ac7340.png";